"use client";

import Link from "next/link";
import { capture } from "@/lib/analytics/events";
import type { AnalyticsEvents } from "@/lib/analytics/events";

/**
 * A landing-page "start / create your portfolio" CTA (CM-2). Renders the same
 * Next <Link href="/dashboard"> the marketing page used before — it just fires
 * the `portfolio_cta_click` conversion event on click. Client navigation still
 * happens via <Link>, so the event is fire-and-forget and never delays the nav.
 */
export function PortfolioCtaLink({
  location,
  className,
  children,
}: {
  location: AnalyticsEvents["portfolio_cta_click"]["location"];
  className?: string;
  children: React.ReactNode;
}) {
  return (
    <Link
      href="/dashboard"
      onClick={() => capture("portfolio_cta_click", { location })}
      className={className}
    >
      {children}
    </Link>
  );
}
